    import { saveAs } from "file-saver";
    import { config } from "@/utils/configuration/config";
    import { Document, Packer, Paragraph, TextRun, Footer, Header, ImageRun, HeadingLevel, AlignmentType,
            Table, TableRow, TableCell, SectionType, SectionProperties, VerticalAlign, TextDirection, WidthType,
             TableOfContents, ParagraphChild, BorderStyle, MathSum} from "docx";
    import store from "@/store/index";
    import Inform_i18n from "@/plugins/Inform_i18n";
    import Ship from "@/model/Ship";

    class DocService {
        private static instance: DocService

        private constructor() {
            if (config.app.useFirebase) {
                //console.log(" DocService Constructor.")
            }
        }
          public static getInstance(): DocService {
        
            //console.log("DocService - getInstance")
            if (!DocService.instance) {
                DocService.instance = new DocService();
            }
        
            return DocService.instance;
          }
        


        public createDoc (data){

            //console.log("DocService - createDoc", data, store.getters.languageState)

            const text_translated = Inform_i18n.getTranslationText(store.getters.languageState)
            const confData : object[] = [
                {name: "Vref", units: "knot", code:"vref"},
                {name: "PME", units: "kW", code:"pme"},
                {name: "CFMe", units: "gCO2/g Fu", code:"cfme"},
                {name: "SFCME", units: "g/KWh", code:"sfcme"},
                {name: "PAE", units: "kW", code:"pae"},
                {name: "CFAE", units: "gCO2/g Fu", code:"cfae"},
                {name: "SCFAE", units: "g/kWh", code:"scfae"},
                {name: "PPTI", units: "kW", code:"ppti"},
                {name: "Peff", units: "kW", code:"peff"},
                {name: "PAEEff", units: "kW", code:"paeeff"},
                {name: text_translated.capacity, units: "tons", code:"capacity"},
                {name: "fi", units: "", code:"fi"},
                {name: "fc", units: "", code:"fc"},
                {name: "fl", units: "", code:"fl"},
                {name: "fw", units: "", code:"fw"},
                {name: "fm", units: "", code:"fm"},
                {name: "fj", units: "", code:"fj"},
            ];
            
            const ShipGeneralData: object[] = [
                {name: text_translated.attainedEEXI, units: "gCO2/t. Nm", code:"attainedEEXI"},
                {name: text_translated.grossTonnage, units: "(t)", code:"gt"},
                {name: text_translated.capacityDeadWeight, units: "(t)", code:"capacityDeadWeight"},
                {name: text_translated.displacementVolume, units: "m&sup3", code:"displacementVolume"},
                {name: text_translated.lengthOverall, units: "m", code:"loa"},
                {name: text_translated.lengthbtwPerpendicular, units: "m", code:"lpp"},
                {name: text_translated.summerLoad, units: "m", code:"ds"},
                {name: text_translated.breadth, units: "m", code:"bs"},
                {name: text_translated.shipSpeed, units: "kn", code:"manualVref"},
                {name: text_translated.vTanks, units: "m&sup3;", code:"vTanks"},
                {name: text_translated.vsService, units: "", code:"vsService"},
                {name: text_translated.dwtsService, units: "", code:"dwtsService"},
                {name: text_translated.psService, units: "", code:"psService"},
                {name: text_translated.lwtReferenceDesign, units: "t", code:"lwtReferenceDesign"},
                {name: text_translated.lwtEnhancedDesign, units: "t", code:"lwtEnhancedDesign"},
                {name: text_translated.deadweightCSR, units: "t", code:"dwtCsr"},
                {name: text_translated.lightweightCSR, units: "t", code:"lwtCsr"},
                {name: text_translated.capacityNoSideloaders, units: "t", code:"capacityNoSideloaders"},
                {name: text_translated.capacitySideloaders, units: "t", code:"capacitySideloaders"},
                {name: text_translated.highSpeedCruise, units: "", code:"highSpeedCruise"},
                {name: text_translated.capacityNoRORORamp, units: "t", code:"capacityNoRORORamp"},
                {name: text_translated.capacityRORORamp, units: "t", code:"capacityRORORamp"},
                {name: text_translated.cb, units: "", code:"cb"},
                {name:'cranes', units: "", code:"cranes"},
                
            ];

            const carbonData: object[] = [
                {name: text_translated.attainedEEXI, units: "gCO2/t. Nm", code:"attaineddii"},
                {name: "configurationName", units: "gCO2/t. Nm", code:"configurationName"},
                {name: "resultsForConfiguration", units: "gCO2/t. Nm", code:"resultsForConfiguration"},
                {name: "requiredcii", units: "gCO2/t. Nm", code:"requiredcii"},
                {name: "distancePerYear", units: "gCO2/t. Nm", code:"distancePerYear"},
            ];
            
            const Data2: object[] = [
                {name: text_translated.attainedEEXI, units: "gCO2/t. Nm", code:"attainedEEXI"},
                {name: text_translated.micellaneousCosts, units: "€", code:"micellaneousCosts"},
                {name: text_translated.technicalStopDuration, units: "€", code:"technicalStopDuration"},
                {name: text_translated.dailyCosts, units: "€", code:"dailyCosts"},
                {name: text_translated.initialInvestment, units: "€", code:"initialInvestment"},
                {name: text_translated.financing, units: "", code:"financing"},
                {name: text_translated.amountToFinance, units: "", code:"amountToFinance"},
                {name: text_translated.interestRate, units: "", code:"interestRate"},
                {name: text_translated.amortizationPeriod, units: "", code:"amortizationPeriod"},
                {name: text_translated.discountRate, units: "", code:"discountRate"},

            ]
            

            const dataConfig = this.objectConf(data.ship, confData);
            const dataEco = this.objectConf(data.ship, Data2);
            const dataBase = this.objectBase(data.ship, ShipGeneralData);
            const carbon = this.carbonDataGetter(data.ship);

            const childrenSection: Table[] = [] ;

            Object.keys(dataConfig).forEach(element => {
                childrenSection.push(
                    new Table({
                        borders:{
                            top: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "ffffff",
                            },
                            bottom: {
                                style: BorderStyle.DOUBLE,
                                size: 3,
                                color: "ffffff",
                            },
                            left: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "ffffff",
                            },
                            right: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                            insideHorizontal: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                            insideVertical: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                        },
                        width: { 
                            size: 6000, 
                            type: WidthType.AUTO, 
                        }, 
                        columnWidths: [6000,6000], 

                        rows: [

                            new TableRow({
                                children: [
                                    new TableCell({
                                        

                                        children:[
                                            new Paragraph({
                                                heading: HeadingLevel.HEADING_3,
                                                alignment: AlignmentType.LEFT,
                                                children: [ new TextRun({
                                                    text: text_translated.configuration + ": " + data.ship.configurations[element].name,
                                                    font: "Calibri",
                                                })],
                                            }),
                                            this.createChartShipData(dataConfig[element], 'carbon')
                                        ]
                                    }),
                                    new TableCell({
                                        children:[
                                            this.createChartShipData(dataEco[element], 'eco')
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    })

            )});

            const childrenSection2: Table[] = [] ;

            Object.keys(carbon).forEach(element => {
                childrenSection2.push(
                    new Table({
                        borders:{
                            top: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "ffffff",
                            },
                            bottom: {
                                style: BorderStyle.DOUBLE,
                                size: 3,
                                color: "ffffff",
                            },
                            left: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "ffffff",
                            },
                            right: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                            insideHorizontal: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                            insideVertical: {
                                style: BorderStyle.DASH_DOT_STROKED,
                                size: 3,
                                color: "#ffffff",
                            },
                        },
                        width: { 
                            size: 6000, 
                            type: WidthType.AUTO, 
                        }, 
                        columnWidths: [6000,6000], 

                        rows: [

                            new TableRow({
                                children: [
                                    new TableCell({
                                        

                                        children:[
                                            new Paragraph({
                                                heading: HeadingLevel.HEADING_3,
                                                alignment: AlignmentType.LEFT,
                                                children: [ 
                                                new TextRun({
                                                    text: text_translated.configuration + ": " + carbon[element].configurationName,
                                                    font: "Calibri",
                                                }),
                                            ],
                                        }),
                                        this.createChartShipData(carbon[element], 'eco')
                                        ]
                                    }),
                                   /*  new TableCell({
                                        children:[
                                            this.createChartShipData(carbon[element], 'eco')
                                        ],
                                    }), */
                                ],
                            }),
                        ],
                    })

            )});

            const ecoEfficiencyArray = {};
            let lengthEco = 0;

            for (let index = 0; index < data.ship.configurations.length; index++) {
                if (data.ship.configurations[index].economicData != undefined && 
                    data.ship.configurations[index].economicData != null){
                        if(data.ship.configurations[index].economicData.ecoEfficiency != undefined){
                            lengthEco = data.ship.configurations[index].economicData.ecoEfficiency.length
                        }else{
                            lengthEco = 0;
                        }
                }
            }

            let titulo_boolean = true;
            for (let index = -1; index < lengthEco; index++) {
                const helperArray: object[] = [];
                data.ship.configurations.forEach(element => {

                    if(titulo_boolean){
                        helperArray.push(element.name);
                    }else{
                        helperArray.push(element.economicData.ecoEfficiency[index]);
                    }
                    
                    
                });
                titulo_boolean = false;
                ecoEfficiencyArray["Año " + (index+1)] = helperArray;           
                }
            
            const ecoEfficiencyTable = this.createChartShipData(ecoEfficiencyArray, 'ecoefficient');
            const carbonTable = this.createChartShipData(carbon, 'eco');
            const shipDataTable = this.createChartShipData(dataBase, 'eco');




        
            const doc_ships_first_page = new Document({
                
            sections: [
                {
                    headers: { 
                            default: new Header({
                                children: [new Paragraph("ECOBUQ")],
                            }),
                        },
                    footers: {
                            default: new Footer({
                                children: [new Paragraph("Footer text")],
                            }),
                        }, 

                    properties: {
                        type: SectionType.CONTINUOUS,
                        },
                
                    children: [ 
                            new Paragraph({
                            heading: HeadingLevel.TITLE,
                            alignment: AlignmentType.CENTER,
                            children: [ new TextRun({
                                text:  text_translated.title,
                                font: "Calibri",
                            })],
                        }),
                        
                        new Paragraph({
                            heading: HeadingLevel.HEADING_1,
                            alignment: AlignmentType.CENTER,
                            thematicBreak: true,
                            children: [ new TextRun({
                                text: data.ship.name + " (IMO " + data.ship.imo + ')\n',
                                font: "Calibri",
                            })],
                            }),  
                        new Paragraph({
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.LEFT,
                            thematicBreak: true, 
                            children: [ new TextRun({
                                text: text_translated.titleBase,
                                font: "Calibri",
                        })]}),
                            
                        shipDataTable
                        ],
                    },
                    {
                    headers: { 
                            default: new Header({
                                children: [new Paragraph("ECOBUQ")],
                            }),
                        },
                    footers: {
                            default: new Footer({
                                children: [new Paragraph("Footer text")],
                            }),
                        }, 

                    properties: {
                        type: SectionType.CONTINUOUS,
                        },
                
                    children:   childrenSection             
                            
                    },
                    {
                    headers: { 
                            default: new Header({
                                children: [new Paragraph("ECOBUQ")],
                            }),
                        },
                    footers: {
                            default: new Footer({
                                children: [new Paragraph("Footer text")],
                            }),
                        }, 

                    properties: {
                        type: SectionType.CONTINUOUS,
                        },
                
                    children:    [
                        new Paragraph({
                            heading: HeadingLevel.HEADING_2,
                            alignment: AlignmentType.CENTER,
                            thematicBreak: true,
                            children: [ new TextRun({
                                text: text_translated.indiceHeader,
                                font: "Calibri",
                            })]}),                   
                        
                        
                        ecoEfficiencyTable]            
                            
                },
                {
                    headers: { 
                            default: new Header({
                                children: [new Paragraph("ECOBUQ")],
                            }),
                        },
                    footers: {
                            default: new Footer({
                                children: [new Paragraph("Footer text")],
                            }),
                        }, 

                    properties: {
                        type: SectionType.CONTINUOUS,
                        },
                
                    children:   childrenSection2            
                            
                    },
            ]
        });
        

        Packer.toBlob(doc_ships_first_page).then(blob => {
            //console.log(blob);
            saveAs(blob,   data.ship.name + "_inform.docx");
            //console.log("Document created successfully");
          });
            
            
        }
        private objectConf(ship: Ship, dataRequired){
            
            const final_shipConf = {};

            Object.keys(ship.configurations).forEach(key => {
                const shipConf = {};
                dataRequired.forEach(element => {
                    Object.keys(ship.configurations[key]).forEach(key2 => {
                        if(key2 == element.code){
                            shipConf[element.name] = ship.configurations[key][key2];
                        }else{
                            if(key2 == 'AuxiliaryEngineEmissions' ||
                                key2 == 'AuxiliaryEngineEnergySavings' ||
                                key2 == 'MainEngineEmissions' ||
                                key2 == 'MainEngineEnergySavings' && key != 'name'){
                                    
                                Object.keys(ship.configurations[key][key2]).forEach(key3 => {
                                    Object.keys(ship.configurations[key][key2][key3]).forEach(key4 => {
                                        if(key4 == element.code){
                                            if(key2 == 'AuxiliaryEngineEmissions' || key2 == 'MainEngineEmissions'){
                                                shipConf[element.name + '-' + ship.configurations[key][key2][key3].name] = ship.configurations[key][key2][key3][key4];
                                            }else{
                                                shipConf[element.name + '-' + ship.configurations[key][key2][key3].type] = ship.configurations[key][key2][key3][key4];
                                            }
                                        }
                                    });
                                });
                            }

                            if(key2 == 'economicData'){
                                Object.keys(ship.configurations[key][key2]).forEach(ECOkey3 => {
                                    if(ECOkey3 == element.code){
                                        shipConf[element.name] = ship.configurations[key][key2][ECOkey3];
                                    }
                                });
                            }

                        }
                        final_shipConf[key] = shipConf;
                    });   
                });

            });
      
            //console.log("final_shipConf.- ", final_shipConf);
            
            return final_shipConf;
        }


        private carbonDataGetter(ship: Ship){
            const final_data = {};
            
            Object.keys(ship.carbonData).forEach(key => {
                const data = {};
                    if(key === 'configurationsForCarbon'){
                        Object.keys(ship.carbonData.configurationsForCarbon).forEach(key2 => {
                            const dataConfig = {};
                            Object.keys(ship.carbonData.configurationsForCarbon[key2]).forEach(key3 => {
                                if(key3 === 'attainedcii' || key3 === 'configurationName') {
                                    dataConfig[key3] = ship.carbonData.configurationsForCarbon[key2][key3];
                                }else if(key3 == 'resultsForConfiguration'){
                                    let count = 2022;
                                        Object.keys(ship.carbonData.configurationsForCarbon[key2][key3]).forEach(key4 => {
                                            dataConfig[String(count)] = ship.carbonData.configurationsForCarbon[key2][key3][key4];
                                            count++;
                                        });
                                    }
                                });
                                final_data[key2] = dataConfig;
                        });
                }
        });
            
            //console.log("===============CARBON=================", final_data);
            
            return final_data;
        }

        private ecoEfficiencyPart(ship: Ship): number {
            const num = ship.configurations.length

            return num;
        }


        private objectBase(ship: Ship, data: Object) {
            const final = {};
            
            Object.keys(data).forEach(data_ele => {
                //console.log(data_ele)
                Object.keys(ship).forEach(ship_ele => {
                    if(data[data_ele].code == ship_ele){
                        final[data[data_ele].name] = ship[ship_ele];
                    }
                    
                });
            });

            //console.log(final)
            return final;
        }


        
        private createChartShipData(ship, typeChart: string): Table{
            
            const row : TableRow[] = [];
            let width1 : number = 0;
            let width2 : number = 0;
            typeChart == 'eco'? width1 = 2000 : width1 = 3000;
            typeChart == 'ecoefficient'? width2 = 1000 : width2 = 2000;
            typeChart == 'eco'? width2 = 1000 : width2 = 2000;

            if(typeChart == 'ecoefficient'){
                let length = ship['Año 1'].length;
                length +=1;

            }

                Object.keys(ship).forEach(element => {
                    
                    if(typeChart == 'ecoefficient'){
                        const harray: String[] = [];
                        if(element == 'Año 0'){
                            harray.push('')
                        }else{
                            harray.push(element)
                        }
                        harray.concat(ship[element])
                        
                        
                        row.push( this.createRow( harray.concat(ship[element]) ) )     
                    }else{
                        row.push( this.createRow(element ,  String(ship[element]) ) )     

                    }
                });
            
            let table;
            if(typeChart == 'ecoefficient'){

                const rowWidths: number[] = []
                for (let index = 0; index < length; index++) {
                     rowWidths.push(2000)
                    
                }

                 table = new Table({
                    width: { 
                        size: 1000, 
                        type: WidthType.AUTO, 
                    }, 
                    margins: {
                        top: 10,
                        right: 0,
                        bottom: 0,
                        left: 10,
                    },
                    columnWidths: rowWidths, 
                    rows: row,
                    alignment: AlignmentType.LEFT,
                })
                
            }else{
                 table = new Table({
                    width: { 
                        size: 1000, 
                        type: WidthType.AUTO, 
                    }, 
                    margins: {
                        top: 10,
                        right: 0,
                        bottom: 0,
                        left: 10,
                    },
                    columnWidths: [width1 , width2], 
                    rows: row,
                    alignment: AlignmentType.LEFT,
                })
            }

            return table;
        }

        private createRow(...args: any[]) {
            const children : TableCell[] = [];
            args.forEach(element => {
                if(Array.isArray(element)){
                    //console.log("######ARRAY",element );
                    element.forEach(element2 => {
                        children.push(this.createCell(String(element2)))
                    })
                    
                }else{
                    children.push(this.createCell(String(element)))
                }
            });
            const row = new TableRow({
                children: 
                    children
                ,
            });
            
            return row;
        }

        private createCell(data: string){
            const cell = new TableCell({
                children: [
                    new Paragraph({ 
                        children:[ 
                            new TextRun({ 
                                text: data,
                                size: 20,
                                font: "Calibri",
                        })]
                    }),
                ],
                verticalAlign: VerticalAlign.CENTER,
            });

            return cell;
        }
    }

    export default DocService;